module.exports = {
  baseURL: 'https://apifaice.tastenpic.com'
}
